goog.provide('el8.app.shared.tagInputOpts');

goog.require('el8.app.shared.dialog.addEditDocTag');
goog.require('el8.appshared.mindreaderOpts');

el8.app.shared.tagInputOpts = {

    codedDocumentTags: function(opts) {
        return {
            mindreaderOpts: $.extend(el8.appshared.mindreaderOpts.codedDocumentTags(), {
                containerLeftOffset: 10,
                minQueryLength: 0,
                showOnFocus: true,
                modifyRenderCb: function(params) {
                    if (!params.searchString && params.numMatches) {
                        // description for the emptyQueryData search
                        var totalCount = params.resultsMap.total_count;
                        var infoDivText;
                        if (totalCount > params.numMatches) {
                            infoDivText = "Displaying your practice's first " +
                                            params.numMatches + " document tags.";
                        } else {
                            infoDivText = "Displaying your practice's document tags.";
                        }
                        params.infoDiv.text(infoDivText);
                    }
                }
            }),
            promptCreateTagFn: function(val, handleTagItemFn) {
                if (!val) { return; }
                el8.app.shared.dialog.addEditDocTag.show(val, handleTagItemFn);
            },
            convertTextToItemFn: function(val, handleTagItemFn, handleEmptyItemFn) {
                if (!val) { return; }

                $.el8_ajax({
                    url: el8.service.urls.get('documentTags'),
                    data: { 'value': val },
                    success: function(data) {
                        if (data) {
                            handleTagItemFn(data);
                        } else {
                            handleEmptyItemFn();
                        }
                    }
                });
            }
        };
    }

};

